module.exports = __webpack_public_path__ + "static/media/juvederm.ea93da4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/juvederm.png
// module id = 277
// module chunks = 0